export default __webpack_public_path__ + "static/media/sanmar8.0faf8b6f.jpg";